module.exports = __webpack_public_path__ + "img/user-clock-solid.6edb9b4f.svg";